import { get } from '@/httpRequest'

export interface ISessionListRequest {
  page?: number
  size?: number
}

export interface ISessionListResponse {
  count: number
  list: ISessionListItem[]
}

export interface ISessionListItem {
  id: string
  session_type: number
  session_id: string
  session_name: string
  session_avatar_url: string
  last_message_type: number
  last_message_content: string
  last_message_created_at: number
  last_read_at: null | number
  last_message_sender_id: string
}

export const getSessionList = async (params: ISessionListRequest) => {
  const response = await get<ISessionListResponse>(
    `/imApi/session/list`,
    params
  )

  return response
}
